(function(){
'use strict';
var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function initReveal(root){
  var nodes=(root||document).querySelectorAll('[data-pz-reveal]:not([data-pz-seen])');
  if(!nodes.length)return;
  if(RM||!('IntersectionObserver' in window)){nodes.forEach(function(n){n.setAttribute('data-pz-seen','');n.classList.add('is-in');});return;}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('is-in');io.unobserve(e.target);});},{rootMargin:'0px 0px -8% 0px',threshold:0.06});
  nodes.forEach(function(n){n.setAttribute('data-pz-seen','');io.observe(n);});
}
document.addEventListener('click',function(e){
  var btn=e.target.closest('[data-pz-qty-step]');if(!btn)return;e.preventDefault();
  var wrap=btn.closest('[data-pz-qty]');if(!wrap)return;
  var input=wrap.querySelector('input');if(!input)return;
  var min=parseInt(input.getAttribute('min')||'1',10);
  var maxAttr=input.getAttribute('max');var max=maxAttr?parseInt(maxAttr,10):Infinity;
  var step=btn.getAttribute('data-pz-qty-step')==='up'?1:-1;
  var next=(parseInt(input.value,10)||min)+step;
  input.value=Math.min(max,Math.max(min,next));
  input.dispatchEvent(new Event('change',{bubbles:true}));
});
document.addEventListener('click',function(e){
  var btn=e.target.closest('.pz-acc__btn');if(!btn)return;
  var item=btn.closest('.pz-acc__item');var acc=btn.closest('.pz-acc');if(!item)return;
  var open=item.classList.contains('is-open');
  if(acc&&acc.hasAttribute('data-pz-acc-single')){acc.querySelectorAll('.pz-acc__item.is-open').forEach(function(i){if(i!==item){i.classList.remove('is-open');var b=i.querySelector('.pz-acc__btn');if(b)b.setAttribute('aria-expanded','false');}});}
  item.classList.toggle('is-open',!open);btn.setAttribute('aria-expanded',String(!open));
});
document.addEventListener('click',function(e){
  var tab=e.target.closest('[data-pz-tab]');if(!tab)return;
  var group=tab.closest('[data-pz-tabs]');if(!group)return;
  var name=tab.getAttribute('data-pz-tab');
  group.querySelectorAll('[data-pz-tab]').forEach(function(t){var on=t.getAttribute('data-pz-tab')===name;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',String(on));});
  group.querySelectorAll('[data-pz-panel]').forEach(function(p){p.hidden=p.getAttribute('data-pz-panel')!==name;});
});
var WK='pz_wishlist';
function wlRead(){try{return JSON.parse(localStorage.getItem(WK)||'[]');}catch(err){return [];}}
function wlWrite(l){try{localStorage.setItem(WK,JSON.stringify(l));}catch(err){}}
function wlSync(){
  var list=wlRead();
  document.querySelectorAll('[data-pz-wish]').forEach(function(b){b.classList.toggle('is-on',list.indexOf(b.getAttribute('data-pz-wish'))>-1);});
  var n=list.length;
  document.querySelectorAll('[data-pz-wish-count]').forEach(function(el){el.textContent=n;el.hidden=n===0;});
}
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-pz-wish]');if(!b)return;e.preventDefault();e.stopPropagation();
  var handle=b.getAttribute('data-pz-wish');var list=wlRead();var i=list.indexOf(handle);
  if(i>-1){list.splice(i,1);}else{list.push(handle);}
  wlWrite(list);wlSync();
  if(i===-1){b.classList.add('pz-pop');setTimeout(function(){b.classList.remove('pz-pop');},320);}
});
function refreshCart(){
  document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  document.documentElement.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));
}
function openCartDrawer(){
  var d=document.querySelector('cart-drawer-component, #cart-drawer, .cart-drawer');
  if(d){
    if(typeof d.open==='function'){try{d.open();return true;}catch(err){}}
    if(typeof d.showDialog==='function'){try{d.showDialog();return true;}catch(err){}}
    var dlg=d.querySelector('dialog');
    if(dlg&&typeof dlg.showModal==='function'){try{dlg.showModal();return true;}catch(err){}}
  }
  return false;
}
document.addEventListener('click',function(e){
  var btn=e.target.closest('[data-pz-add]');if(!btn)return;e.preventDefault();
  var id=btn.getAttribute('data-pz-add');if(!id)return;
  var sel=btn.getAttribute('data-pz-qty-target');
  var qtyEl=sel?document.querySelector(sel):null;
  var qty=qtyEl?(parseInt(qtyEl.value,10)||1):1;
  var label=btn.querySelector('[data-pz-add-label]')||btn;
  var original=label.textContent;
  btn.disabled=true;label.textContent='Adding…';
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)?window.Shopify.routes.root:'/';
  fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
  .then(function(r){return r.ok?r.json():Promise.reject(r);})
  .then(function(){
    label.textContent='Added ✓';refreshCart();
    setTimeout(function(){openCartDrawer();label.textContent=original;btn.disabled=false;},450);
  })
  .catch(function(){label.textContent=original;btn.disabled=false;window.location.href='/cart';});
});
function initGallery(root){
  root.querySelectorAll('[data-pz-gallery]:not([data-pz-ready])').forEach(function(g){
    g.setAttribute('data-pz-ready','');
    var stage=g.querySelector('[data-pz-gallery-stage]');
    var thumbs=g.querySelectorAll('[data-pz-gallery-thumb]');
    if(!stage)return;
    var slides=stage.querySelectorAll('[data-pz-slide]');
    function goTo(i){
      var slide=slides[i];if(!slide)return;
      stage.scrollTo({left:slide.offsetLeft-stage.offsetLeft,behavior:RM?'auto':'smooth'});
      thumbs.forEach(function(t,ti){t.classList.toggle('is-active',ti===i);});
      var c=g.querySelector('[data-pz-gallery-counter]');if(c)c.textContent=(i+1)+' / '+slides.length;
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i);});});
    g.querySelectorAll('[data-pz-gallery-nav]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var dir=btn.getAttribute('data-pz-gallery-nav')==='next'?1:-1;
        var cur=0,best=Infinity;
        slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft-stage.offsetLeft-stage.scrollLeft);if(d<best){best=d;cur=i;}});
        goTo(Math.min(slides.length-1,Math.max(0,cur+dir)));
      });
    });
    if('IntersectionObserver' in window&&slides.length){
      var so=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.intersectionRatio>0.6){
            var i=Array.prototype.indexOf.call(slides,en.target);
            thumbs.forEach(function(t,ti){t.classList.toggle('is-active',ti===i);});
            var c=g.querySelector('[data-pz-gallery-counter]');if(c)c.textContent=(i+1)+' / '+slides.length;
          }
        });
      },{root:stage,threshold:[0.61]});
      slides.forEach(function(s){so.observe(s);});
    }
  });
}
function initSticky(root){
  root.querySelectorAll('[data-pz-sticky-bar]:not([data-pz-ready])').forEach(function(bar){
    bar.setAttribute('data-pz-ready','');
    var sentinel=document.querySelector(bar.getAttribute('data-pz-sticky-after')||'#pz-buybox-anchor');
    if(!sentinel||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(entries){
      var e=entries[0];
      bar.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0);
    },{threshold:0});
    io.observe(sentinel);
  });
}
function initCountdown(root){
  root.querySelectorAll('[data-pz-countdown]:not([data-pz-ready])').forEach(function(el){
    el.setAttribute('data-pz-ready','');
    var end=new Date(el.getAttribute('data-pz-countdown')).getTime();
    if(isNaN(end)){el.hidden=true;return;}
    var s={d:el.querySelector('[data-cd="d"]'),h:el.querySelector('[data-cd="h"]'),m:el.querySelector('[data-cd="m"]'),s:el.querySelector('[data-cd="s"]')};
    function pad(n){return String(n).padStart(2,'0');}
    var t=setInterval(tick,1000);
    function tick(){
      var diff=end-Date.now();
      if(diff<=0){el.hidden=true;clearInterval(t);return;}
      if(s.d)s.d.textContent=pad(Math.floor(diff/86400000));
      if(s.h)s.h.textContent=pad(Math.floor(diff%86400000/3600000));
      if(s.m)s.m.textContent=pad(Math.floor(diff%3600000/60000));
      if(s.s)s.s.textContent=pad(Math.floor(diff%60000/1000));
    }
    tick();
  });
}
document.addEventListener('click',function(e){
  var open=e.target.closest('[data-pz-drawer-open]');
  if(open){var d=document.querySelector(open.getAttribute('data-pz-drawer-open'));if(d){d.classList.add('is-open');document.body.style.overflow='hidden';}return;}
  var close=e.target.closest('[data-pz-drawer-close]');
  if(close){var dd=close.closest('[data-pz-drawer]');if(dd){dd.classList.remove('is-open');document.body.style.overflow='';}}
});
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  document.querySelectorAll('[data-pz-drawer].is-open').forEach(function(d){d.classList.remove('is-open');document.body.style.overflow='';});
});
document.addEventListener('change',function(e){
  var form=e.target.closest('[data-pz-autosubmit]');
  if(form)form.submit();
});
var RV='pz_recently_viewed';
function rvTrack(){
  var el=document.querySelector('[data-pz-rv-track]');if(!el)return;
  var handle=el.getAttribute('data-pz-rv-track');if(!handle)return;
  var list;try{list=JSON.parse(localStorage.getItem(RV)||'[]');}catch(err){list=[];}
  list=list.filter(function(h){return h!==handle;});list.unshift(handle);list=list.slice(0,12);
  try{localStorage.setItem(RV,JSON.stringify(list));}catch(err){}
}
function rvRender(){
  var section=document.querySelector('[data-pz-rv-section]');if(!section)return;
  var grid=section.querySelector('[data-pz-rv-grid]');if(!grid)return;
  var current=section.getAttribute('data-pz-rv-exclude')||'';
  var list;try{list=JSON.parse(localStorage.getItem(RV)||'[]');}catch(err){list=[];}
  list=list.filter(function(h){return h&&h!==current;}).slice(0,4);
  if(!list.length){section.hidden=true;return;}
  var done=0,html=[];
  list.forEach(function(h,idx){
    fetch('/products/'+h+'?view=pz-card')
    .then(function(r){return r.ok?r.text():'';})
    .then(function(t){html[idx]=t;})
    .catch(function(){html[idx]='';})
    .then(function(){
      if(++done===list.length){
        var out=html.filter(Boolean).join('');
        if(out){grid.innerHTML=out;section.hidden=false;initReveal(grid);wlSync();}
        else{section.hidden=true;}
      }
    });
  });
}
function initHeaderScroll(){
  function onScroll(){document.documentElement.classList.toggle('pz-scrolled',(window.scrollY||0)>24);}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
}
function boot(root){
  root=root||document;
  initReveal(root);initGallery(root);initSticky(root);initCountdown(root);wlSync();
}
function start(){boot();initHeaderScroll();rvTrack();rvRender();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
document.addEventListener('shopify:section:load',function(e){boot(e.target);});
document.addEventListener('shopify:section:select',function(e){boot(e.target);});
window.PZ={boot:boot,reveal:initReveal,wishlistSync:wlSync};
})();
